/**
 * Shared by the "+ Create Link" and "+ Create QR Code" buttons so they render at the same width
 * despite their labels being different lengths.
 */
export const SHARING_ACTION_BUTTON_MIN_WIDTH = 160;
